import { FC } from 'react';
import { SpaEntityType } from 'shared-types/Spa';
import { BackgroundImgixWrapper } from '@common/components/BackgroundImgixWrapper';
import { FormStep } from '../../../types';
import { ExperiencesGroupWrapper, SpaImageWrapperMobile } from '../ExperiencesGroup.styles';
import {
  ExperiencesGroupOptionsBase,
  renderExperienceDetailComponent,
} from './ExperiencesGroupOptionsBase';
interface Props {
  selectionGroup: Omit<FormStep, 'step' | 'type'>;
  allOptionsIncluded?: boolean;
  spaExperiences: Partial<SpaEntityType>[];
  plusMinusSpaOption: (
    type: 'plus' | 'minus',
    id: number,
    optionId: number,
    startTime?: string
  ) => void;
  totalGuests: number;
  dayNumber: number;
}
export const ExperiencesGroupOptionsMobile: FC<Props> = (props) => {
  return (
    <ExperiencesGroupOptionsBase
      {...props}
      renderExperienceItem={({ exp, experienceDetailProps, imageUrl, isClasses }) => (
        <ExperiencesGroupWrapper key={exp.id}>
          <div data-unavailable={exp?.unAvailable}>
            {isClasses ? (
              <div />
            ) : (
              <SpaImageWrapperMobile isFullDim>
                <BackgroundImgixWrapper src={imageUrl} isFullDim customHeight="100%" />
              </SpaImageWrapperMobile>
            )}
            {renderExperienceDetailComponent(experienceDetailProps, isClasses)}
          </div>
        </ExperiencesGroupWrapper>
      )}
      renderGroup={(content) => <>{content}</>}
    />
  );
};
